// @flow

import type {Hotel, Journey} from 'redux/v1/journey/models';
import type {Hotel as MappedHotel, ImageGallery} from 'types/imageGallery';

import {useSelector} from 'react-redux';

import {getImages, isImageLoaded} from 'redux/v1/image/reducer';
import {getJourney} from 'redux/v1/journey/reducer';

const useHotelImage = (): ImageGallery => {
  const {hotel}: Journey = useSelector(getJourney);
  const images = useSelector(getImages);
  const preparedImages = images?.map((image) => image.image_url);
  const promoImages = images
    ?.filter((image) => image.promo)
    .map((image) => image.image_url);
  const imageLoaded = useSelector(isImageLoaded);

  if (!imageLoaded) {
    return {
      hotel: mapHotel(hotel),
      promoImage: '',
      images: [],
    };
  }

  return {
    hotel: mapHotel(hotel),
    promoImage:
      images.length > 0 ? promoImages[0] || preparedImages[0] : hotel.image,
    images: images.length > 0 ? images : [],
    parsedImages: images.length > 0 ? preparedImages : [],
  };
};

const mapHotel = (hotel: Hotel): MappedHotel => {
  return {
    name: hotel.name,
    category: hotel.stars,
    categoryType: hotel.hotelCategoryVerified ? 'verified' : 'unverified',
    city: hotel.city,
    country: hotel.country,
    region: hotel.region,
  };
};

export default useHotelImage;
